import type { FunctionComponent } from 'react';
import { useBackgroundSound } from '../utils/sound';

export interface StateProps {
	enabled: boolean;
	volume: number;
	volumeBaseModifier: number;
}

export interface DispatchProps {}

export interface OwnProps {
	src: string;
}

type Props = StateProps & DispatchProps & OwnProps;

const BackgroundSound: FunctionComponent<Props> = (props: Props) => {
	const { enabled, volume, volumeBaseModifier, src } = props;
	useBackgroundSound(src, enabled, volume * volumeBaseModifier);
	return null;
};

export default BackgroundSound;
